import { render, staticRenderFns } from "./XQueryBuilder.vue?vue&type=template&id=5094abb8&"
import script from "./XQueryBuilder.vue?vue&type=script&lang=js&"
export * from "./XQueryBuilder.vue?vue&type=script&lang=js&"
import style0 from "./XQueryBuilder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports